<template><div><h2>debounce</h2>
<div class="warning">
<p>请注意了解 <code>debounce</code> 和 <code>throttle</code> 的区别。如果尚不清楚，请<code>google</code>之。</p>
</div>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { debounce } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

debounce(func, [wait=<span class="hljs-number">0</span>], [options={}])
</code></pre>
<p><a href="https://lodash.com/docs/#debounce">详细文档</a></p>
<h2>throttle</h2>
<pre class="hljs"><code><span class="hljs-keyword">import</span> { throttle } <span class="hljs-keyword">from</span> <span class="hljs-string">'vux'</span>

throttle(func, [wait=<span class="hljs-number">0</span>], [options={}])
</code></pre>
<p><a href="https://lodash.com/docs/#throttle">详细文档</a></p>
</div></template><script>
export default {
  head: {"title":"debounce | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// debounce-throttle-305.vue?4e287e68